module.exports = {"API_ROOT":"http://vipcardionet.com:7003","DC_ROOT":"http://www.heaguard.com:5002","ETC_ROOT":"http://www.heaguard.com:2000/#/","VERSION":"2.4.1"}


//////////////////
// WEBPACK FOOTER
// ./static/config.json
// module id = IuJc
// module chunks = 1